import { render, staticRenderFns } from "./print.vue?vue&type=template&id=31bb4d58&"
import script from "./print.vue?vue&type=script&lang=ts&"
export * from "./print.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports